import React, { useEffect } from 'react';
import InnerLayout from 'app-layout/inner-layout';

import { trackScrolling, updateProductInfo } from './utils';
import AuthLayout from './auth-layout';

const AppContainer = (props) => {
  const {
    activeStep,
    multiSiteFileUploadSuccess,
    selectedRadio,
    setActiveStep,
    setSelectedRadio,
    setToast,
    toast,
    showSteps,
    setMultiSiteFileUploadSuccess,
    setNotification,
    notificationState,
    toastState,
    closeNetworkCoveragePopup,
    steps,
    setIsAuthJourney,
    isAuthJourney,
    toggelNotification,
    pageData,
    featureToggler
  } = props;

  const isdedicatedJourney = window.location.pathname.includes('internet-leased-line');

  useEffect(() => {
    updateProductInfo();
    window.addEventListener('scroll', trackScrolling);
    return () => window.removeEventListener('scroll', trackScrolling);
  }, []);

  return (
    <React.Fragment>
      {isAuthJourney && (
        <AuthLayout
          isdedicatedJourney={isdedicatedJourney}
          isUnAuthJourney={!isAuthJourney}
          activeStep={activeStep}
          multiSiteFileUploadSuccess={multiSiteFileUploadSuccess}
          selectedRadio={selectedRadio}
          setActiveStep={setActiveStep}
          setSelectedRadio={setSelectedRadio}
          setToast={setToast}
          toast={toast}
          showSteps={showSteps}
          setMultiSiteFileUploadSuccess={setMultiSiteFileUploadSuccess}
          setNotification={setNotification}
          notificationState={notificationState}
          toastState={toastState}
          closeNetworkCoveragePopup={closeNetworkCoveragePopup}
          steps={steps}
          toggelNotification={toggelNotification}
          pageData={pageData}
          featureToggler={featureToggler}
        />
      )}

      {!isAuthJourney && (
        <InnerLayout
          setIsAuthJourney={setIsAuthJourney}
          isdedicatedJourney={isdedicatedJourney}
          isUnAuthJourney={!isAuthJourney}
          activeStep={activeStep}
          multiSiteFileUploadSuccess={multiSiteFileUploadSuccess}
          selectedRadio={selectedRadio}
          setActiveStep={setActiveStep}
          setSelectedRadio={setSelectedRadio}
          setToast={setToast}
          toast={toast}
          showSteps={showSteps}
          setMultiSiteFileUploadSuccess={setMultiSiteFileUploadSuccess}
          setNotification={setNotification}
          notificationState={notificationState}
          toastState={toastState}
          closeNetworkCoveragePopup={closeNetworkCoveragePopup}
          steps={steps}
          toggelNotification={toggelNotification}
          pageData={pageData}
          featureToggler={featureToggler}
        />
      )}
    </React.Fragment>
  );
};

export default AppContainer;
